// src/components/dashboard/pages/DeliveryScheduleList/components/DeliveryScheduleTable.jsx
import React from 'react';
import DataTable from 'react-data-table-component';
import { Calendar, Truck, MapPin, Users, Scale, Clock, Pen, Eye } from 'lucide-react';
import { tableStyles } from '../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../i18n';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../../utils/common';
import { 
  DELIVERY_SCHEDULE_COLUMNS,
  DeliveryStatusBadge,
  PriorityBadge 
} from '../services/DeliveryScheduleDataGenerator';

export class DeliveryScheduleTable extends React.Component {
  constructor() {
    super();
    this.state = {
      copiedId: null
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
  }

  handlePageChange = (page) => {
    if (this.props.onChangePage) {
      this.props.onChangePage(page);
    }
  };

  handleRowsPerPageChange = (newLimit, page) => {
    if (this.props.onChangeRowsPerPage) {
      this.props.onChangeRowsPerPage(newLimit);
    }
  };

  handleRowClick = (row, e) => {
    console.log('Row clicked:', row);
    
    // Navigate to details page when row is clicked
    if (this.props.history && row.id) {
      console.log('Navigating to schedule details for ID:', row.id);
      this.props.history.push(`/delivery-schedule/${row.id}/edit`);
    } else {
      console.log('Cannot navigate - missing history or row.id');
    }
  };

  handleEdit = (schedule, e) => {
    e?.stopPropagation();
    console.log('Edit schedule:', schedule);
    if (this.props.history && schedule.id) {
      this.props.history.push(`/delivery-schedule/${schedule.id}/edit`);
    }
  };

  handleView = (schedule, e) => {
    e?.stopPropagation();
    console.log('View schedule:', schedule);
    if (this.props.history && schedule.id) {
      this.props.history.push(`/delivery-schedule/${schedule.id}/view`);
    }
  };

  getColumns() {
    const {
      currentPage = 1,
      limit = 15,
    } = this.props;

    const baseColumns = [
      ...DELIVERY_SCHEDULE_COLUMNS,
      {
        name: 'Actions',
        width: '120px',
        center: true,
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <Link
              className="btn-new btn-sm"
              to={`/delivery-schedule/${row.id}/edit`}
              onClick={(e) => this.handleEdit(row, e)}
            >
              <Pen/>
            </Link>
            <Link
              className="btn-new btn-sm"
              to={`/delivery-schedule/${row.id}/view`}
              onClick={(e) => this.handleView(row, e)}
              style={{ 
                backgroundColor: '#f3f4f6',
                color: '#374151',
                border: '1px solid #d1d5db'
              }}
            >
              <Eye/>
            </Link>
          </div>
        ),
      },
    ];

    return baseColumns;
  }

  render() {
    const { siteVisits = [], currentPage = 1, limit = 15, total = 0 } = this.props;

    const customTableStyles = {
      ...tableStyles,
      rows: {
        ...tableStyles.rows,
        style: {
          ...tableStyles.rows?.style,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#f8f9fa',
          },
        },
      },
    };

    return (
      <>
        <DataTable
          key={`${currentPage}-${limit}`}
          title=""
          columns={this.getColumns()}
          data={siteVisits}
          customStyles={customTableStyles}
          highlightOnHover
          pagination
          paginationServer
          paginationTotalRows={total}
          paginationPerPage={limit}
          paginationDefaultPage={currentPage}
          paginationRowsPerPageOptions={[15, 25, 50, 100]}
          paginationComponentOptions={{
            rowsPerPageText: i18n.t('rows_per_page'),
            rangeSeparatorText: i18n.t('out'),
          }}
          onChangeRowsPerPage={this.handleRowsPerPageChange}
          onChangePage={this.handlePageChange}
          onRowClicked={this.handleRowClick}
        />
      </>
    );
  }
}

export default DeliveryScheduleTable;